export default __webpack_public_path__ + "i18n/translations/translation-bn.353baa47.json";